export default "__VITE_ASSET__CYI61FgI__"